module.exports = __webpack_public_path__ + "img/q-10-6@2x.828e146c.png";